export default __webpack_public_path__ + "static/media/example.c0217c75.md";